module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows-8824f84613f80f89c6a6177a7da2e74b.png";